import React from "react";

class Resume extends React.Component {
    state = {  }
    render() { 
        return (
            <section id="resume" class="resume-area pt-130 rpt-100 rel z-1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="big-icon mt-85 rmt-0 rmb-55 wow fadeInUp delay-0-2s">
                                <i class="flaticon-asterisk-1"></i>
                            </div>
                        </div>
                        <div class="col-lg-9">
                            <div class="row">
                                <div class="col-xl-8 col-lg-9">
                                    <div class="section-title mb-60 wow fadeInUp delay-0-2s">
                                        <span class="sub-title mb-15">My Resume</span>
                                        <h2>Real <span>Problem Solutions</span> Experience</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="resume-items-wrap">
                                <div class="row justify-content-between">
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-3s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Jun 2023 - Present</span>
                                                <h4>Software Developer</h4>
                                                <span class="company">Digital Business Solution SA (AFG Holding)</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-4s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Jul 2022- Jun 2023</span>
                                                <h4>Full Stack Developer</h4>
                                                <span class="company">Dtectio</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-2s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Feb 2022 - Jul 2022</span>
                                                <h4>Software Engineer (Intern)</h4>
                                                <span class="company">PT Kews International Trading</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-4s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Mar 2021 - Jan 2022</span>
                                                <h4>Full Stack Developer</h4>
                                                <span class="company">Digitrade</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-4s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Mar 2021 - Jan 2022</span>
                                                <h4>Mobile / Web Developer (Intern)</h4>
                                                <span class="company">Unikeza</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-5 col-md-6">
                                        <div class="resume-item wow fadeInUp delay-0-4s">
                                            <div class="icon">
                                                <i class="far fa-arrow-right"></i>
                                            </div>
                                            <div class="content">
                                                <span class="years">Jul 2020 - Oct 2020</span>
                                                <h4> Developer (Intern)</h4>
                                                <span class="company">Cabinet I2T Group</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-lines">
                <span></span><span></span>
                <span></span><span></span>
                <span></span><span></span>
                <span></span><span></span>
                <span></span><span></span>
                </div>
            </section>
        );
    }
}
 
export default Resume;